import {translateFunction} from "../../../../localization/TranslationService";
import {Document} from "../../models/Document";
import React, {useState} from "react";
import {
	Alert,
	Backdrop,
	Box,
	Button,
	CircularProgress,
	Stack,
	TextField
} from "@mui/material";
import {graphQLServices} from "../../../../services/GraphQLServices";
import gqlSaveComment from "../graphql/mutations/gqlSaveComment";
import {Save} from "@mui/icons-material";
import {toast} from "react-toastify";

const translate = translateFunction("SureBaseDocuments");
interface IEditCommentCardProps{
	document?: Document;
	onClose?: () => void;
	reloadDocument?: () => void;
	readOnly: boolean;
}


export const EditCommentCard: React.FC<IEditCommentCardProps> = (props) => {
	const [errorMessage, setErrorMessage] = useState<string>("");
	const [comment, setComment] = useState<string>(props.document?.comment??"");
	const [loading, setLoading] = useState<boolean>(false);
	
	async function updateComment()  {
		setLoading(true);
		setErrorMessage("");
		
		await graphQLServices.documentsClient.query({
			query: gqlSaveComment,
			variables: {
				input: {
					documentId: props.document?.id,
					comment: comment
				}
			},
		}).then(() => {
			toast.success(translate(`Comment saved.`));
			props.reloadDocument && props.reloadDocument();
			props.onClose && props.onClose();
		});
		setLoading(false);
	}
	
	return <>
		<Backdrop open={loading}><CircularProgress/></Backdrop>
		{errorMessage &&
			<Alert severity={"error"}>{JSON.stringify(errorMessage)}</Alert>
		}
		{!props.readOnly &&
			<Box sx={{marginBottom: 2}} justifyContent="space-between" flexDirection={"column"}>
				<Button key={"saveButton"} endIcon={<Save/>} variant={"contained"}
					onClick={updateComment}>{translate("Save")}</Button>
			</Box>
		}
		<Stack spacing={1}>
			
			<TextField
				
				key={"comment"}
				label={translate("Comment")}
				value={comment}
				multiline
				onChange={(event) => setComment(event.target.value)}
				InputProps={{
					readOnly: props.readOnly,
					style: {backgroundColor: (props.readOnly) ? "lightgray": "white"},
				}}
				
				InputLabelProps={{
					shrink: true
				}}
			/>
		</Stack>
	</>;
};
